import React from 'react';
import { cx } from './cx';

interface PageProps {
  children: React.ReactNode;
  className?: string;
}

/** Root of every design-system page: sets font, colour, canvas and section spacing. */
const Page: React.FC<PageProps> = ({ children, className }) => (
  // .page-body is the template's slot under the header and beside the sidebar.
  <div className="page-body">
    <div className={cx('ds-page', className)}>{children}</div>
  </div>
);

interface PageHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  eyebrow?: React.ReactNode;
  actions?: React.ReactNode;
}

/** One per page. Title is the page name from the sidebar; actions are page-level buttons. */
export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, eyebrow, actions }) => (
  <header className="ds-page-header">
    <div>
      {eyebrow && <div className="ds-page-header__eyebrow">{eyebrow}</div>}
      <h1 className="ds-page-header__title">{title}</h1>
      {subtitle && <p className="ds-page-header__subtitle">{subtitle}</p>}
    </div>
    {actions && <div className="ds-page-header__actions">{actions}</div>}
  </header>
);

export default Page;
